import useLocale from 'next-translate/useTranslation';
import React from 'react';

import BarwenockLogo from '~/svg/Barwenock.svg';
import BengsLogo from '~/svg/Bengs.svg';
import LalamoveLogo from '~/svg/Lalamove.svg';
import StripeLogo from '~/svg/Stripe.svg';
import SupabaseLogo from '~/svg/Supabase.svg';
import TailwindLogo from '~/svg/Tailwind.svg';
import TypescriptLogo from '~/svg/Typescript.svg';

const logos = [
  // {
  //   component: <NextJsLogo className='h-64 w-auto grayscale dark:fill-white' />,
  //   url: 'https://nextjs.org/',
  // },
  {
    component: (
      <LalamoveLogo className='h-36 w-auto grayscale dark:fill-white' />
    ),
    url: 'https://nextjs.org/',
  },
  {
    component: <BarwenockLogo className=' h-16 w-auto grayscale' />,
    url: 'https://nextjs.org/',
  },
  {
    component: (
      <TailwindLogo className='h-20 w-auto grayscale dark:fill-white' />
    ),
    url: 'https://tailwindcss.com/',
  },
  {
    component: (
      <SupabaseLogo className='h-40 w-auto grayscale dark:fill-white' />
    ),
    url: 'https://supabase.com/',
  },

  {
    component: <StripeLogo className='h-24 w-auto grayscale' />,
    url: 'https://stripe.com/',
  },
  {
    component: (
      <TypescriptLogo className='h-48 w-auto grayscale dark:fill-white' />
    ),
    url: 'https://www.typescriptlang.org/',
  },
  {
    component: <BengsLogo className='h-48 w-auto grayscale' />,
    url: 'https://www.typescriptlang.org/',
  },
];

const LogosCloud = () => {
  const { t } = useLocale('common');

  return (
    <section className='bg-white py-8 dark:bg-gray-900 '>
      <div className='lg:px-18 mx-auto  text-center'>
        {/* <span className='text-sm font-semibold uppercase text-gray-500'>
          {t('Join 100,000+ creators, brands & publishers')}
        </span> */}
        <div className=' flex items-center justify-center'>
          {/* 1. */}
          <div className='relative mt-5 h-20 w-[200%] overflow-hidden'>
            {/* 2. */}
            <div className='animate absolute left-0 flex h-20 w-[200%] items-center justify-around gap-20'>
              {/* 3 */}
              {logos.map((logo, index) => {
                return (
                  <div
                    key={index}
                    className='flex w-[20rem] items-start justify-center dark:text-slate-200'
                  >
                    {logo.component}
                  </div>
                );
              })}
              {logos.map((logo, index) => {
                return (
                  <div
                    key={index}
                    className='flex w-[20rem] items-start justify-center'
                  >
                    {logo.component}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LogosCloud;
